<div class="messages-widget">
  <button (click)="onOpen()" [className]="notSeenRoomCounts > 0?'messages has-unreaded':'messages'">
    <span *ngIf="notSeenRoomCounts > 0" class="rounded-full inline-block absolute  -top-2 text-sm w-[25px] h-[25px] leading-[25px]  bg-primary">{{(notSeenRoomCounts>9)?'9+':notSeenRoomCounts}}</span>
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.0913 20.8632L9.70203 20.7499L9.39406 21.0136C7.80415 22.3748 6.03388 23.0621 4.6486 23.4077C4.51029 23.4422 4.37608 23.4733 4.24656 23.5012C5.86505 21.4933 6.22749 20.0532 6.28924 19.3123L6.32145 18.9257L6.02462 18.6761C4.17869 17.1233 3.0835 15.0583 3.0835 12.8333C3.0835 8.23945 7.83157 4.25 14.0002 4.25C20.1688 4.25 24.9168 8.23945 24.9168 12.8333C24.9168 17.4272 20.1688 21.4167 14.0002 21.4167C12.6259 21.4167 11.3081 21.2172 10.0913 20.8632Z" stroke="currentColor" stroke-width="1.5"/>
    </svg>

  </button>

  <div class="messages-widget-body">
    <app-custom-dropdown className="r-40 message-widget {{dropClassName}}" [menuIndex]="3" >
      <div class="app-custom-dropdown-content">
        <div class="display-flex justify-space-between align-item-center">
          <div class="title">{{'messages'| translate}}</div>
        </div>

        <div class="tab-section">
          <ul class="row tab-layer">
            <li class="tab-item col-4">
              <a [ngClass]="activeTab==='individual'?'active show':''"  (click)="showTab('individual')" class="nav-link " data-toggle="tab">
                <span class="text-tab">
                  {{'individual' | translate}}
                </span>
                <span *ngIf="individualNotSeenRoomsCount" class="tab-not-seen-count">
                  {{individualNotSeenRoomsCount}}
                </span>
              </a>
            </li>
            <li class="tab-item col-4">
              <a [ngClass]="activeTab==='group'?'active show':''"  (click)="showTab('group')" class="nav-link " data-toggle="tab">
                <span class="text-tab">
                  {{'group' | translate}}
                 </span>

                <span *ngIf="groupNotSeenRoomsCount" class="tab-not-seen-count">
                  {{groupNotSeenRoomsCount}}
                </span>
              </a>
            </li>
            <li class="tab-item col-4">
              <a [ngClass]="activeTab==='generated'?'active show':''"  (click)="showTab('generated')" class="nav-link" data-toggle="tab">
                <span class="text-tab">
                    {{'generated' | translate}}
                </span>
                <span *ngIf="generatedNotSeenRoomsCount" class="tab-not-seen-count">
                    {{generatedNotSeenRoomsCount}}
                </span>
              </a>
            </li>
          </ul>
        </div>

        <div class="message-search container">
          <div class="scroll-block">
            <app-custom-search-input
              class="bg-transparent white w-100"
              labelClass="green"
              labelText="{{'search' | translate}}"
              (changeInput) = "getRooms($event)"
              (changeOnkeyup) = "getRooms($event)"
            ></app-custom-search-input>
            <app-dropdown  [options]='options' (callback)='res($event)' [dropDawnstatus]='openInviteDropDawnOptions' [updateVariable] = 'updateVariable'></app-dropdown>

        </div>

         <app-scrollable-wall
           (load)="loadMore()"
           height="60vh"
           scrollHeight="99%"
         >
         <div class="users-list">

           <div class="list-item" *ngFor="let room of rooms">
             <a class="nav-link room-item">
               <app-chat-room-item
                 [room]="room"
                 (openChat) = "openChatWidget($event)"
                 (deleteRoom) = "deleteRoom($event)"
                 (editRoom)= "editRoom($event)"
                 [showOptions] = "true"
                 [updateVariable] = "room.updateVariable"
               >
               </app-chat-room-item>
             </a>
           </div>
           <app-skeleton-message *ngIf="loading">
           </app-skeleton-message>

         </div>
         </app-scrollable-wall>
       </div>


      </div>
      <div class="app-custom-dropdown-footer">
       <div class=" display-flex justify-space-between">
         <div> <a class="text-normal" (click)="onClose()" [routerLink]="['/messages']" > {{'view_all'| translate}}</a></div>
         <div> <a class="text-normal" (click)="markAllAsRead()" > {{'mark_all_as_read'| translate}}</a></div>
       </div>
      </div>
    </app-custom-dropdown>
  </div>

</div>
